// components/navbar/NavLinks.js
import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const NavLinks = ({ isMobile, closeMenu }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Toggle dropdown for mobile
  const toggleDropdown = (e) => {
    if (isMobile) {
      e.preventDefault();
      setIsDropdownOpen(!isDropdownOpen);
    }
  };

  // Handle navigation item click
  const handleItemClick = () => {
    if (isMobile && closeMenu) {
      closeMenu();
    }
  };

  // Apply appropriate classes based on mobile or desktop view
  const linkClassName = isMobile 
    ? "mobile-nav-item" 
    : "nav-item";
  
  const dropdownClassName = isMobile
    ? "mobile-nav-dropdown"
    : "nav-dropdown";
  
  const dropdownToggleClassName = isMobile
    ? "mobile-dropdown-toggle"
    : "dropdown-toggle";
  
  const dropdownMenuClassName = isMobile
    ? "mobile-dropdown-menu"
    : "dropdown-menu";
  
  const dropdownItemClassName = isMobile
    ? "mobile-dropdown-item"
    : "dropdown-item";

  return (
    <>
      <NavLink
        to="/anime"
        className={({ isActive }) => `${linkClassName} ${isActive ? "active" : ""}`}
        onClick={handleItemClick}
        end
      >
        Anime
      </NavLink>
      
      <NavLink
        to="/manga"
        className={({ isActive }) => `${linkClassName} ${isActive ? "active" : ""}`}
        onClick={handleItemClick}
        end
      >
        Manga
      </NavLink>
      
      <NavLink
        to="/characters"
        className={({ isActive }) => `${linkClassName} ${isActive ? "active" : ""}`}
        onClick={handleItemClick}
        end
      >
        Characters
      </NavLink>
      
      <NavLink
        to="/community"
        className={({ isActive }) => `${linkClassName} ${isActive ? "active" : ""}`}
        onClick={handleItemClick}
        end
      >
        Community
      </NavLink>
      
      {/* Categories Dropdown */}
      <div className={dropdownClassName}>
        <button
          className={dropdownToggleClassName}
          onClick={toggleDropdown}
          aria-haspopup="true"
          aria-expanded={isMobile ? isDropdownOpen : undefined}
        >
          More
          <span 
            className="dropdown-arrow" 
            style={isMobile && isDropdownOpen ? { transform: 'rotate(180deg)' } : {}}
          >
            ▼
          </span>
        </button>
        
        {/* Show the menu differently based on mobile/desktop */}
        {(isMobile && isDropdownOpen) || !isMobile ? (
          <div className={dropdownMenuClassName} role="menu">
            <NavLink
              to="/About"
              className={dropdownItemClassName}
              onClick={handleItemClick}
            >
              About
            </NavLink>
            
            <NavLink
              to="/faq"
              className={dropdownItemClassName}
              onClick={handleItemClick}
            >
              FAQs
            </NavLink>
            
            <NavLink
              to="/support"
              className={dropdownItemClassName}
              onClick={handleItemClick}
            >
              Support
            </NavLink>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default NavLinks;